import type {Mapper} from 'framework';
import type {ConversationDetail} from '../../domain/conversation';
import type {ConversationDetailDto} from '../dto/assistant.dto';
import type {AssistantMessageDtoToAssistantMessageMapper} from './assistant-message-dto-to-assistant-message.mapper';
import type {ConversationDtoToConversationMapper} from './conversation-dto-to-conversation.mapper';

export class ConversationDetailDtoToConversationDetailMapper implements Mapper<
  ConversationDetailDto,
  ConversationDetail
> {
  constructor(
    private readonly conversationMapper: ConversationDtoToConversationMapper,
    private readonly messageMapper: AssistantMessageDtoToAssistantMessageMapper,
  ) {}

  transform(dto: ConversationDetailDto): ConversationDetail {
    return {
      conversation: this.conversationMapper.transform(dto.conversation),
      messages: dto.messages.map(message => this.messageMapper.transform(message)),
    };
  }
}
